import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminTable from 'common/AdminTable';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';

const BACKEND = process.env.REACT_APP_BACKEND;

const CategoryList = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await getRequest('categories');
      setData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch categories:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRemove = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await deleteRequest(`categories/${id}`);
      fetchData();
    } catch (err) {
      console.error('Failed to delete category:', err);
    }
  };

  const tableHeaders = [
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img
            src={`${BACKEND}uploads/${row.original.image}`}
            alt="category"
            width={50}
            height={50}
            style={{ objectFit: 'cover', borderRadius: 4 }}
          />
        ) : (
          <span>No Image</span>
        )
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/categories/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Category List</h4>
      </div>
      <div className="mx-4">
        {data?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={data} />
        ) : (
          <p>No categories available.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryList;
